import { articles } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function HeadlineFeature() {
  const a = articles[0];
  const reads = [articles[1], articles[4], articles[6]];

  return (
    <section id="feature" className="scroll-mt-16 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          index="03"
          eyebrow="Headline"
          title="头条深读"
          desc="每周一条主线，把一段看似热闹的事件放回结构里读。深读不追最快，只求把『为什么』讲透。"
        />

        <article className="grid overflow-hidden rounded-xl border border-background-200 bg-background-100 lg:grid-cols-12">
          <div className="relative lg:col-span-7">
            <img
              src={a.image}
              alt={`${a.title} 头条深读大图`}
              className="h-64 w-full object-cover sm:h-80 lg:h-full"
            />
            <span className="absolute left-4 top-4 rounded bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
              本期头条
            </span>
          </div>

          <div className="flex flex-col justify-center p-6 md:p-9 lg:col-span-5">
            <div className="flex items-center gap-2 text-xs text-foreground-500">
              <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">{a.categoryName}</span>
              <span>{a.time}</span>
              <span>·</span>
              <span>约 {a.readMinutes} 分钟</span>
            </div>
            <h3 className="mt-4 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
              {a.title}
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">{a.excerpt}</p>

            <ul className="mt-5 space-y-2.5 border-t border-background-300 pt-5">
              {["先定位『生产方』是谁，再看它为何反复选择相同结构。", "交叉核对三处公开时间点，排除巧合的干扰。", "把单点新闻放回整条流水线里，判断这只是其中一环。"].map(
                (k, i) => (
                  <li key={k} className="flex items-start gap-2.5 text-sm text-foreground-700">
                    <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded bg-accent-500/15 text-[11px] font-bold text-accent-700">
                      {i + 1}
                    </span>
                    {k}
                  </li>
                )
              )}
            </ul>

            <a
              href="#columns"
              className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              阅读完整深读
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </article>

        <div className="mt-5 grid gap-3 md:grid-cols-3">
          {reads.map((r) => (
            <a
              key={r.id}
              href="#columns"
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-3 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="grid h-9 w-9 shrink-0 place-items-center rounded-md bg-foreground-950 text-sm text-background-100">
                <i className="ri-file-text-line" />
              </span>
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold text-foreground-950">{r.title}</p>
                <p className="mt-0.5 text-xs text-foreground-500">{r.categoryName} · {r.readMinutes} 分钟</p>
              </div>
              <i className="ri-arrow-right-line ml-auto text-background-400 transition-transform group-hover:translate-x-1" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}